import "./index.css";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { AuthContextProvider } from "./store/authContext/authContextProvider";
import App from "./App.tsx";
import store from "./store/index.tsx";

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </Provider>,
);
